import Provider from './provider';

export const wrapRootElement = Provider;

// trigger an immediate page refresh when an update is found
export const onServiceWorkerUpdateReady = () => window.location.reload();